import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from "@angular/router";
import { Router } from '@angular/router';

import { AuthService } from '../../Service/auth'; // Ajusta la ruta de tus carpetas
import { ToastService } from '../../Service/toast-service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterOutlet],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login implements OnInit {
  loginForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    public toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // 🛡️ BLINDAJE ANTI-PARPADEO: Destruye cualquier sesión previa colgada en memoria
    // Al limpiar el localStorage aquí, obligas al app.html a esconder el menú de inmediato.
    this.authService.logout();

    this.loginForm = this.fb.group({
      coId: ['', [Validators.required, Validators.minLength(3)]],
      userId: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', [Validators.required]]
    });
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      this.toastService.showDanger('Captura Requerida', 'Por favor, digite su ID de usuario y contraseña.');
      return;
    }

    const { coId, userId, password } = this.loginForm.value;

    console.log('Despachando credenciales de acceso:', { coId, userId, password: '***' });

    // =========================================================================
    // 🚀 LLAMADA DINÁMICA DE TRES PASOS (CERO HARDCODING):
    // Despachamos coId, userId y password de forma unificada hacia el AuthService.
    // =========================================================================
    // 🚀 Llamada dinámica Multi-Tenant de tres vías
    this.authService.login(coId, userId, password).subscribe({
      next: (res) => {
        console.log('>>> [SECURITY JDE] Login exitoso. Datos recibidos:', res);

/*         this.toastService.showSuccess(
          'Acceso Autorizado',
          `Bienvenido al Portal, ${res.userId.toUpperCase()}. Sesión iniciada con éxito.`
        ); */

        // =========================================================================
        // 🔮 ENGRANAJE DE REDIRECCIÓN DINÁMICA INTELIGENTE (CERO HARDCODING):
        // Evaluamos el arreglo de roles que entregó el backend para decidir el destino.
        // Se añade un pequeño retardo preventivo asíncrono para que la memoria del
        // navegador asiente el LocalStorage antes de que los AuthGuards se disparen.
        // =========================================================================
        setTimeout(() => {
          if (res.roles && res.roles.includes('ROLE_SUPER_ADMIN')) {
            console.log('👑 [ROUTING] Súper Administrador detectado. Abriendo Saas Cockpit...');
            this.router.navigate(['/admin/saas']); // 💡 CORREGIDO: Hace match milimétrico con tus rutas
          } else if (res.roles && res.roles.includes('ROLE_ADMIN')) {
            console.log('🛠️ [ROUTING] Administrador de Taller detectado. Abriendo módulo operativo...');
            this.router.navigate(['/home']);    
          } else {
            console.warn('⚠️ [ROUTING] Rol genérico o sin privilegios asignados. Aplicando ruta por defecto.');
            this.router.navigate(['/home']); 
          }
          this.cdr.detectChanges();
        }, 50); // 50 milisegundos de respiro para blindar el flujo SSR
      },
      error: (err) => {
        console.error('Fallo en autenticación JDE:', err);
        this.toastService.showDanger(
          'Fallo de Inicio de Sesión',
          err.error?.error || 'Credenciales inválidas, compañía errónea o servidor fuera de línea.'
        );
        this.cdr.detectChanges();
      }
    });
  }
}
